import { Injectable } from '@angular/core';
import {Data} from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class PriceChangesService {

  dateFrom: Date;
  dateTo: Date;

  constructor() { }
}
